import { render } from "./ProfilePagePart1UserNamePFP.vue?vue&type=template&id=a98f6c26"
import script from "./ProfilePagePart1UserNamePFP.vue?vue&type=script&lang=js"
export * from "./ProfilePagePart1UserNamePFP.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__